// extracted by mini-css-extract-plugin
module.exports = {"devicesList":"VoiceDevicesList_devicesList__zT8m0","skeleton":"VoiceDevicesList_skeleton__EenLl"};